import PubSub from "underpub-js";

var CtaSmall = function(options) {

	this.options = {
		$el: false,
		baseClass: 'comp-CtaSmall',
	};

	$.extend(true, this.options, options);

};

CtaSmall.prototype.init = function() {

	var self = this;

	this.$csrfField = this.options.$el.find("[name='CRAFT_CSRF_TOKEN']");

	// Gets a CSRF input field
	fetch('/actions/blitz/csrf/input')
  .then(result => {
		return result.text();
	})
  .then(result => {
		self.$csrfField.replaceWith(result);
	});

};

export default CtaSmall;
